<template>
  <div :class="{ big3: settlementType == 5 }" v-loading="pageLoading">
    <div class="table-head table-row" v-if="tableData.length" :class="{ big: listType == 3, big2: activityType == 3 }">
      <div>产品/险种名称</div>
      <div>投/被保人</div>
      <div>结算保费(元)</div>
      <div v-if="listType != 3">服务费比例</div>
      <div v-else-if="activityType == 2">活动奖励比例</div>
      <div v-if="settlementType == 5">续费状态</div>
      <div v-if="listType != 3">应结费用(元)</div>
      <div v-if="activityType != 3">
        <span v-if="activityType == 2">活动收入(元)</span>
        <span v-else>实际收入(元)</span>
      </div>
      <div>保单/险种状态</div>
    </div>
    <div v-for="(bean, i) in tableData" :key="i" class="card">
      <div class="table-info table-row">
        <div>承保时间：{{ bean.issueTime | timeSubstr(0, 16) }}</div>
        <div>保单号：{{ bean.policyNo }}</div>
        <div>
          <span v-if="[1, 2].includes(bean.mechanLevel * 1)">出单机构：</span>
          <span v-else>出单员工：</span>
          {{ bean.mechanName }}
        </div>
        <div>结算日期：{{ bean.balanceDate | timeSubstr(0, 10) }}</div>
        <div>结算类型：{{ all.BALANCE_TYPE[bean.type] }}</div>
        <div>出单地区：{{ bean.holderArea }}</div>
      </div>
      <div class="table-info2 table-row" :class="{ big: listType == 3, big2: activityType == 3 }">
        <div>
          <tooltip :txt-info="bean.productName"></tooltip>
        </div>
        <div>
          <tooltip :txt-info="bean.policyerName + '/' + bean.insuranceName"></tooltip>
        </div>
        <div>{{ bean.fee }}</div>
        <div v-if="bean.productList.length == 1 && activityType != 3">
          <span v-if="activityType != 2">{{ bean.commission * 1 }}%</span>
          <span v-if="bean.subsidyCommission * 1" class="org-text"><span v-if="activityType != 2">+</span>{{ bean.subsidyCommission }}%</span>
          <activityTip
            v-if="bean.productList && bean.productList[0] && bean.productList[0].activityName"
            :activityName="bean.productList[0].activityName"
            :subsidyCommission="bean.productList[0].subsidyCommission"
            :subsidyIncomes="bean.productList[0].subsidyIncomes"
          ></activityTip>
        </div>
        <div v-else-if="activityType != 3"></div>
        <div v-if="settlementType == 5">
          <span v-if="bean.renewalStatus == 1">待续费</span>
          <span v-else-if="bean.renewalStatus == 2">已续费</span>
          <span v-else-if="bean.renewalStatus >= 3">续费失败</span>
          <span v-else>-</span>
        </div>
        <div v-if="listType != 3">{{ settlementType == 5 ? '-' : bean.policyIncomes }}</div>
        <div v-if="activityType != 3">{{ settlementType == 5 ? '-' : bean.income }}</div>
        <div>{{ all.POLICY_STATUS[bean.policyStatus] }}</div>
      </div>
      <div class="table-body table-row" v-for="(bean2, ii) in bean.productList" :key="ii" v-if="bean.isIncludeAddition == 1">
        <div>
          <tooltip :txt-info="bean2.productName"></tooltip>
        </div>
        <div>
          <tooltip :txt-info="bean.policyerName + '/' + bean.insuranceName"></tooltip>
        </div>
        <div>{{ bean2.fee }}</div>
        <div v-if="activityType != 3">
          <span v-if="activityType != 2">{{ bean2.commission * 1 }}%</span>
          <span v-if="bean2.subsidyCommission * 1" class="org-text"><span v-if="activityType != 2">+</span>{{ bean2.subsidyCommission }}%</span>
          <activityTip
            v-if="bean2.activityName"
            :activityName="bean2.activityName"
            :subsidyCommission="bean2.subsidyCommission"
            :subsidyIncomes="bean2.subsidyIncomes"
          ></activityTip>
        </div>
        <!-- 待续费占位 -->
        <div v-if="settlementType == 5"></div>
        <div>{{ settlementType == 5 ? '-' : bean2.policyIncomes }}</div>
        <div>
          {{ settlementType == 5 ? '-' : bean2.income }}
          <el-popover placement="top" trigger="hover" v-if="bean2.fee * 1 < 0">
            <div>结算后退保扣除相应收入</div>
            <div>上次结算日期：{{ bean2.lastBalanceDate | timeSubstr(0, 10) }}</div>
            <span slot="reference" class="wenhao">?</span>
          </el-popover>
        </div>
        <div>{{ all.POLICY_STATUS[bean2.policyStatus] }}</div>
      </div>
    </div>
    <emptyBox v-if="tableData.length == 0"></emptyBox>
    <el-pagination @current-change="queryList" :page-size="5" background layout="total,prev, pager, next" :total="total"> </el-pagination>
  </div>
</template>
<script>
import activityTip from '@/components/activityTip';
import tooltip from '@/components/tooltip';
export default {
  props: {
    params: null,
    settlementType: null,
    type: null
  },
  components: { activityTip, tooltip },
  data() {
    return {
      pageLoading: false,
      level: '',
      tableData: [],
      all: {},
      listType: '', //结算类型
      activityType: '', //活动类型
      pageSize: 10,
      total: 0
    };
  },
  mounted() {
    this.level = this.$tools.getLocal('userinfo').level;
    this.all = this.$tools.getLocal('all');
    this.listType = this.$route.query.type;
    this.activityType = this.$route.query.activityType;
  },
  methods: {
    getParams() {
      const params = Object.assign({}, this.params);
      if (this.type == 'queryRefund') {
        params.queryRefund = 1;
      }
      if (params.policyType == 2) {
        delete params.mechanLevels;
        delete params.mechanName;
      } else {
        if (params.mechanName) {
          if (params.mechanLevels == '2') {
            params.mechanLevels = '1,2';
          }
        } else {
          delete params.mechanLevels;
        }
      }
      if (!params.mechanId) {
        delete params.mechanId;
      }

      if (params.createTime && params.createTime.length == 2) {
        params.issueTimeStart = params.createTime[0];
        params.issueTimeEnd = params.createTime[1];
      }
      delete params.createTime;
      if (params.nameType == 1) {
        params.policyerName = params.name;
      } else if (params.nameType == 2) {
        params.insuranceName = params.name;
      }
      delete params.nameType;
      delete params.name;
      return params;
    },
    queryList: function (num) {
      const params = this.getParams();
      console.log(params);
      if (num == 1) {
        this.tableData = [];
      }
      params.pageNum = num;
      params.pageSize = 5;
      this.pageLoading = true;
      this.$http({
        url: '/master/policy/read/policys',
        type: 'put',
        params: params
      })
        .then(data => {
          this.tableData = data.data;
          this.total = data.total;
          this.$emit('getData', data);
        })
        .finally(() => {
          this.pageLoading = false;
        });
    }
  }
};
</script>
<style lang="scss"></style>
